import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { ChevronRight } from "untitledui-js-base";
import { Card } from "shared/components/Card";
import { Loader } from "shared/components/Loader";
import { PropertyGroup } from "types/property-group";

interface PropertyGroupInfoProps {
  isLoadingPropertyGroup: boolean;
  propertyGroup?: PropertyGroup;
}

export const PropertyGroupInfo = ({
  isLoadingPropertyGroup,
  propertyGroup
}: PropertyGroupInfoProps) => {
  const dictionary = useUnitsPropertiesDictionary();

  if (isLoadingPropertyGroup)
    return (
      <Card className="w-full h-[98px] flex items-center justify-center">
        <Loader />
      </Card>
    );

  if (!propertyGroup) return null;

  return (
    <div className="space-y-4">
      <Card className="p-6 space-y-2">
        <div className="flex items-center gap-2">
          <p className="text-sm font-bold">Property group</p>
          <ChevronRight className="size-4 stroke-content-100" />
          <p className="text-sm font-medium text-content-500">
            {propertyGroup.name}
          </p>
        </div>
        <p className="text-sm text-content-400">
          {dictionary.Property} will be added to the {propertyGroup.name}{" "}
          {dictionary.property} group
        </p>
      </Card>
    </div>
  );
};
